import { BrowserRouter as Router } from 'react-router-dom';
import './tailwind.css';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './AppRoutes'; // New component

function App() {
  return (
    <div className="">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            borderRadius: '10px',
            background: 'white',
            color: 'black',
          },
        }}
      />
      <Router>
        <div className="flex-grow">
          <AppRoutes />
        </div>
      </Router>
    </div>
  );
}

export default App;
